import { v4 as uuidv4 } from "uuid";

const chillHop = () => {
  return [
    {
      name: "By Chance",
      album: "Cycles",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/03/74d62bc9370a68e440c1b98eaf650344f0a7faea-1024x1024.jpg",
      artist: "SwuM",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=15224",
      color: ["#AE713D", "#283431"],
      id: uuidv4(),
    },
    {
      name: "Mario Kart",
      album: "Cycles",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/03/74d62bc9370a68e440c1b98eaf650344f0a7faea-1024x1024.jpg",
      artist: "SwuM",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=15228",
      color: ["#AE713D", "#283431"],
      id: uuidv4(),
    },
    {
      name: "Self Luv",
      album: "Cycles",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/03/74d62bc9370a68e440c1b98eaf650344f0a7faea-1024x1024.jpg",
      artist: "SwuM",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=15235",
      color: ["#AE713D", "#283431"],
      id: uuidv4(),
    },
    {
      name: "Reflection",
      album: "Reflection",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      artist: "Swørn",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9228",
      color: ["#C24E7E", "#5F1A4B"],
      id: uuidv4(),
    },
    {
      name: "Upset (hold it in)",
      album: "Reflection",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      artist: "Swørn",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=7925",
      color: ["#C24E7E", "#5F1A4B"],
      id: uuidv4(),
    },
    {
      name: "Golden",
      album: "Forest Lore",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/02/7f102bdde417f6ead9a120b2b931449e5c12b4da-1024x1024.jpg",
      artist: "Aarigod",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=13005",
      color: ["#98BB5F", "#42995A"],
      id: uuidv4(),
    },
    {
      name: "Evenfall",
      album: "Forest Lore",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/02/7f102bdde417f6ead9a120b2b931449e5c12b4da-1024x1024.jpg",
      artist: "Aarigod",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=13007",
      color: ["#98BB5F", "#42995A"],
      id: uuidv4(),
    },
    {
        name: "Jazz Cabbage",
        artist: "Ian Ewing, Strehlow",
        cover: "https://chillhop.com/wp-content/uploads/2020/06/49f6e32ca521fbad46a1b281e3893cf6254bf11d-1024x1024.jpg",
        id: uuidv4(),
        active: false,
        audio: "https://mp3.chillhop.com/serve.php/?mp3=9363",
        color: ["#BA4A46", "#FDF0DD"],        

    }
  ];
};

export default chillHop;
